/* ==========================================================================
   Accessibility fixes (WCAG 2.1 AA) – October 2026
   Fixes for third-party content rendered inside the theme
   (BookThatApp events calendar). Loaded with "defer" on every page.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- Colour helpers ---------- */
  function parseRgb(str) {
    var m = String(str || '').match(/rgba?\(\s*(\d+)[,\s]+(\d+)[,\s]+(\d+)(?:[,\s/]+([\d.]+))?/i);
    if (!m) return null;
    if (m[4] !== undefined && parseFloat(m[4]) === 0) return null;
    return [parseInt(m[1], 10), parseInt(m[2], 10), parseInt(m[3], 10)];
  }
  function luminance(rgb) {
    var c = rgb.map(function (v) {
      v = v / 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  }
  function contrast(a, b) {
    var la = luminance(a), lb = luminance(b);
    return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
  }
  var WHITE = [255, 255, 255], DARK = [18, 18, 18];

  /* ---------- Events calendar ---------- */
  function fixCalendar(cal) {
    // 1. Label icon-only buttons
    var labels = {
      'fc-prev-button': 'Previous',
      'fc-next-button': 'Next',
      'fc-prevYear-button': 'Previous year',
      'fc-nextYear-button': 'Next year'
    };
    Object.keys(labels).forEach(function (cls) {
      cal.querySelectorAll('.' + cls).forEach(function (btn) {
        if (!btn.getAttribute('aria-label') && !btn.textContent.trim()) {
          btn.setAttribute('aria-label', labels[cls]);
        }
      });
    });

    // 2. Event thumbnails sit next to the event title, so they are decorative
    cal.querySelectorAll('img:not([alt])').forEach(function (img) {
      img.setAttribute('alt', '');
    });

    // 3. Readable text on coloured event blocks
    cal.querySelectorAll('.fc-event').forEach(function (ev) {
      if (ev.classList.contains('fc-list-item')) return; // list rows use plain text
      var bg = parseRgb(getComputedStyle(ev).backgroundColor);
      if (!bg) return;
      var useDark = contrast(DARK, bg) > contrast(WHITE, bg);
      var col = useDark ? '#121212' : '#ffffff';
      if (ev.dataset.a11yColor === col) return;
      ev.dataset.a11yColor = col;
      ev.style.setProperty('color', col, 'important');
      ev.querySelectorAll('*').forEach(function (child) {
        child.style.setProperty('color', col, 'important');
      });
    });
  }

  function addCalendarHeading() {
    if (!/^\/apps\/bookthatapp\/calendar/i.test(location.pathname)) return;
    if (document.querySelector('main h1, #MainContent h1')) return;
    var main = document.querySelector('#MainContent') || document.querySelector('main');
    if (!main) return;
    // Promote the app's own "Events Calendar" title to the page's main heading
    var title = Array.prototype.find.call(
      main.querySelectorAll('h2, h3, h4'),
      function (h) { return /events calendar/i.test(h.textContent); }
    );
    if (title) {
      title.setAttribute('role', 'heading');
      title.setAttribute('aria-level', '1');
    } else {
      var h1 = document.createElement('h1');
      h1.className = 'visually-hidden';
      h1.textContent = 'Events Calendar';
      main.insertBefore(h1, main.firstChild);
    }
  }


  /* ---------- Homepage "Upcoming Events" widget (BookThatApp) ----------
     The widget renders in a same-origin iframe, so styles can be added inside it. */
  var WIDGET_CSS =
    'a:focus-visible,button:focus-visible,[tabindex]:focus-visible{' +
    'outline:3px solid #258359 !important;outline-offset:-3px !important;border-radius:2px;}' +
    'a:focus:not(:focus-visible){outline:none;}';

  function fixUpcomingWidget() {
    var frames = document.querySelectorAll('.bta-upcoming-event-widget-container iframe');
    frames.forEach(function (frame) {
      if (frame.getAttribute('title') !== 'Upcoming events') {
        frame.setAttribute('title', 'Upcoming events');
      }
      if (!frame.__a11yLoad) {
        frame.__a11yLoad = true;
        frame.addEventListener('load', function () { injectWidgetCss(frame); });
      }
      injectWidgetCss(frame);
    });
    return frames.length > 0;
  }

  function injectWidgetCss(frame) {
    var doc;
    try { doc = frame.contentDocument; } catch (e) { return; }
    if (!doc || !doc.head || doc.getElementById('a11y-widget-css')) return;
    var style = doc.createElement('style');
    style.id = 'a11y-widget-css';
    style.textContent = WIDGET_CSS;
    doc.head.appendChild(style);
  }

  function initCalendars() {
    var cals = document.querySelectorAll('.fc');
    if (!cals.length) return false;
    cals.forEach(function (cal) {
      fixCalendar(cal);
      if (cal.__a11yObserved) return;
      cal.__a11yObserved = true;
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        // setTimeout (not requestAnimationFrame) so it also runs in background tabs
        setTimeout(function () {
          pending = false;
          fixCalendar(cal);
        }, 60);
      }).observe(cal, { childList: true, subtree: true });
    });
    return true;
  }

  function boot() {
    addCalendarHeading();
    var calDone = initCalendars();
    var widgetDone = fixUpcomingWidget();
    if (calDone && widgetDone) return;
    // The calendar and widget are injected by the app after load; watch for them briefly.
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (!calDone) calDone = initCalendars();
      fixUpcomingWidget();
      if ((calDone && document.querySelector('.bta-upcoming-event-widget-container iframe')) || tries > 40) {
        clearInterval(t);
        addCalendarHeading();
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();